"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderVr = void 0;
var React = require("react");
var DetailGalleryState_1 = require("@/pages/detail/states/DetailGalleryState");
exports.renderVr = function (props) {
    var vrIndex = props.gallery.items.findIndex(function (it) { return it.type === DetailGalleryState_1.DetailGalleryItemType.VR; });
    if (vrIndex < 0)
        return null;
    var src = props.gallery.items[vrIndex].src;
    var vrIframeSrc = src + "&play=1";
    return (React.createElement("div", { style: { backgroundColor: '#000', width: '100%', height: '100%' } },
        React.createElement("iframe", { style: { border: 'none', width: '100%', height: '100%' }, src: vrIframeSrc })));
};
